import { IFileType } from "@/store/types/document-type";
import { ISuiteNUmbers } from "@/store/types/control-types";
import { IPart } from "@/store/types/process-type";
import { CacheType } from "@/store/types/cache-types";
import { INotificationType } from "@/store/types/user-types";
import { ActionContext } from "vuex";
import { RootState } from "@/store/types/root";
import { getPersistSort } from "@/plugins/indexDB";

const state = {
  fileTypesCache: { data: [], date: "01/01/2000" } as CacheType<IFileType[]>,
  holidaysCache: {} as CacheType<string[]>,
  partsCache: {} as CacheType<IPart[]>,
  suiteNumbersCache: {} as CacheType<ISuiteNUmbers>,
  notificationConfigCache: {} as CacheType<INotificationType[]>
};

type State = typeof state;

const mutations = {
  setFileTypesCache: (state: State, value: CacheType<IFileType[]>) => {
    state.fileTypesCache = value;
  },

  setHolidaysCache: (state: State, value: CacheType<string[]>) => {
    state.holidaysCache = value;
  },

  setPartsCache: (state: State, value: CacheType<IPart[]>) => {
    state.partsCache = value;
  },

  setSuiteNumbersCache: (state: State, value: CacheType<ISuiteNUmbers>) => {
    state.suiteNumbersCache = value;
  },

  setNotificationConfigCache: (
    state: State,
    value: CacheType<INotificationType[]>
  ) => {
    state.notificationConfigCache = value;
  },

  clearCacheData: (state: State) => {
    state.fileTypesCache = {} as CacheType<IFileType[]>;
    state.holidaysCache = {} as CacheType<string[]>;
    state.partsCache = {} as CacheType<IPart[]>;
    state.suiteNumbersCache = {} as CacheType<ISuiteNUmbers>;
  }
};

const getters = {
  getFileTypesCache: (state: State) => state.fileTypesCache,

  getHolidaysCache: (state: State) => state.holidaysCache,

  getPartsCache: (state: State) => state.partsCache,

  getSuiteNumbersCache: (state: State) => state.suiteNumbersCache,

  getNotificationConfigCache: (state: State) => state.notificationConfigCache,

  getFileTypesCacheById: (state: State) => (_id: number) =>
    state.fileTypesCache.data.find(fileType => fileType.id === _id)
};

const actions = {
  getPersistSortAction: async (
    _: ActionContext<State, RootState>,
    { sortField, tabPersistName }: { sortField: string; tabPersistName: string }
  ) => {
    const sortData = await getPersistSort({
      name: tabPersistName,
      sort: JSON.parse(sortField)
    });
    return Object.entries(sortData)[0];
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
